"use client";

import { useSearchParams } from "next/navigation";
import { type CreatorPortalAccess, useCreatorAuth } from "./creatorAuthContext";

/** Requests carry a program scope; the API cookie proves the creator identity. */
export function useCreatorPortalAccess(): CreatorPortalAccess | null {
  const auth = useCreatorAuth();
  const params = useSearchParams();
  return auth.account?.programs.length
    ? { orgSlug: params.get("orgSlug") ?? auth.account.programs[0]?.slug }
    : null;
}

export function portalHref(
  path: string,
  access: CreatorPortalAccess | null | undefined,
): string {
  const [pathname, query = ""] = path.split("?");
  const params = new URLSearchParams(query);
  params.delete("token");
  if (access?.orgSlug) params.set("orgSlug", access.orgSlug);
  return `${pathname}${params.size ? `?${params}` : ""}`;
}
